import React from "react";
import Modal from "@mui/material/Modal";
import { Box } from "@mui/material";
import { capitalEachLetter } from "utils/capitalEachLetter";

function USPInfoModal({ modifiedDateModal, setModifiedDateModal, Data }) {
  return (
    <Modal open={modifiedDateModal} onClose={() => setModifiedDateModal(false)}>
      <Box
        sx={{
          width: "400px",
          height: "248px",
          bgcolor: "#fff",
          border: "none !important",
          borderRadius: "5px",
          padding: "20px 16px",
          position: "fixed",
          right: "20px",
          bottom: "20px",
          wordBreak: "break-word",
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          color: "#000000",
          fontFamily: "Karla",
          outline: "none !important",
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box sx={{ fontSize: "20px", fontWeight: 500, fontFamily: "Poppins", borderBottom: "1px solid #000", pb: "12px" }}>Modified Details</Box>
          <Box
            sx={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
              alignItems: "center",
              fontSize: "18px",
              fontWeight: 500,
              fontFamily: "Poppins",
              borderBottom: "0.5px solid #000",
              pt: "12px",
              pb: "5px",
            }}
          >
            <Box>Created By</Box>
            <Box>{capitalEachLetter(Data.createdBy)}</Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
              alignItems: "center",
              fontSize: "18px",
              fontWeight: 500,
              fontFamily: "Poppins",
              borderBottom: "0.5px solid #000",
              pt: "12px",
              pb: "5px",
            }}
          >
            <Box>Created time</Box>
            <Box>{Data.createdTime}</Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
              alignItems: "center",
              fontSize: "18px",
              fontWeight: 500,
              fontFamily: "Poppins",
              borderBottom: "0.5px solid #000",
              pt: "12px",
              pb: "5px",
            }}
          >
            <Box>Modified By</Box>
            <Box>{capitalEachLetter(Data.modifiedBy)}</Box>
          </Box>
          <Box sx={{ display: "flex", width: "100%", justifyContent: "space-between", alignItems: "center", fontSize: "18px", fontWeight: 500, fontFamily: "Poppins", pt: "12px", pb: "5px" }}>
            <Box>Modified Time</Box>
            <Box>{Data.modifiedTime}</Box>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}

export default USPInfoModal;
